import { useMemo } from 'react';
import { Typography } from '@prenuvo/halo';

import { useStudyGuard } from '@/shared/guard';
import { isEmpty } from '@/shared/util';

import { extractSkuFromSkuId, getSkuPackage } from '../../util';
import { getServiceInfoNameList } from './header.util';

export function CarePlanServiceInfo() {
  const {
    isPoetryStudy,
    radiologistScan: { poetryMetadata, skuID },
  } = useStudyGuard();

  const servicesInfoNameList = useMemo(
    () => getServiceInfoNameList(poetryMetadata?.servicesInfo ?? []).join(' • '),
    [poetryMetadata?.servicesInfo],
  );

  const skuPackageName = useMemo(() => getSkuPackage(extractSkuFromSkuId(skuID)), [skuID]);

  const show = {
    services: isPoetryStudy,
  };

  if (show.services) {
    if (isEmpty(poetryMetadata?.servicesInfo)) {
      return null;
    }

    return (
      <div className="relative -top-2 flex-1 pl-1">
        <Typography
          as="span"
          className="inline-block text-neutral-400 dark:text-neutral-400"
          translationKey="FCT.REPORTING.HEADER.CARE_PLAN_SERVICE_INFO"
          values={{ info: servicesInfoNameList }}
          variant="paragraph-sm"
        />
      </div>
    );
  }

  return (
    <div className="relative -top-2 flex-1 pl-1">
      <Typography
        key={skuPackageName}
        as="span"
        className="inline-block text-neutral-400 dark:text-neutral-400"
        translationKey="FCT.REPORTING.HEADER.CARE_PLAN_SERVICE_INFO"
        values={{ info: skuPackageName }}
        variant="paragraph-sm"
      />
    </div>
  );
}
